document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('[data-pristine-header]');
  var toggle = document.querySelector('[data-pristine-mobile-toggle]');
  var menu = document.querySelector('[data-pristine-mobile-menu]');
  var search = document.querySelector('[data-pristine-search]');
  var searchOpen = document.querySelector('[data-pristine-search-open]');
  var searchClose = document.querySelector('[data-pristine-search-close]');
  var cart = document.querySelector('[data-pristine-cart-preview]');
  var cartOpen = document.querySelector('[data-pristine-cart-open]');
  var cartClose = document.querySelector('[data-pristine-cart-close]');

  function onScroll() {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 24);
  }

  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  if (toggle && menu && header) {
    toggle.addEventListener('click', function () {
      var isOpen = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-pristine-submenu]').forEach(function (button) {
    button.addEventListener('click', function () {
      var name = button.getAttribute('data-pristine-submenu');

      document.querySelectorAll('[data-pristine-submenu-panel]').forEach(function (panel) {
        panel.classList.toggle(
          'is-open',
          panel.getAttribute('data-pristine-submenu-panel') === name
        );
      });
    });
  });

  document.querySelectorAll('[data-pristine-submenu-back]').forEach(function (button) {
    button.addEventListener('click', function () {
      var panel = button.closest('[data-pristine-submenu-panel]');
      if (panel) panel.classList.remove('is-open');
    });
  });

  if (search && searchOpen) {
    searchOpen.addEventListener('click', function () {
      search.classList.add('is-open');

      var input = search.querySelector('input');

      if (input) {
        window.setTimeout(function () {
          input.focus();
        }, 80);
      }
    });
  }

  if (search && searchClose) {
    searchClose.addEventListener('click', function () {
      search.classList.remove('is-open');
    });
  }

  if (search) {
    search.addEventListener('click', function (event) {
      if (event.target === search) {
        search.classList.remove('is-open');
      }
    });
  }

  if (cart && cartOpen) {
    cartOpen.addEventListener('click', function () {
      cart.classList.add('is-open');
    });
  }

  if (cart && cartClose) {
    cartClose.addEventListener('click', function () {
      cart.classList.remove('is-open');
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    if (search) search.classList.remove('is-open');
    if (cart) cart.classList.remove('is-open');
  });
});

/* Product gallery */
(function () {
  function initializeProductGalleries() {
    document.querySelectorAll('[data-pf-gallery]').forEach(function (gallery) {
      var mainImage = gallery.querySelector('[data-pf-main-image]');

      gallery.querySelectorAll('[data-pf-thumb]').forEach(function (button) {
        button.addEventListener('click', function () {
          var imageSource = button.getAttribute('data-image');
          var imageAlt = button.getAttribute('data-alt') || '';

          if (imageSource && mainImage) {
            mainImage.src = imageSource;
            mainImage.alt = imageAlt;
          }

          gallery.querySelectorAll('[data-pf-thumb]').forEach(function (thumbnail) {
            thumbnail.classList.remove('is-active');
          });

          button.classList.add('is-active');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProductGalleries);
  } else {
    initializeProductGalleries();
  }
})();

/* Independent Pristine AJAX Quick Add */
(function () {
  function getShopifyRoot() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  async function getCart() {
    var response = await fetch(getShopifyRoot() + 'cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Unable to load the cart.');
    }

    return response.json();
  }

  function updateCartCount(cartData) {
    if (!cartData) return;

    var count = cartData.item_count || 0;

    document
      .querySelectorAll(
        '[data-pristine-cart-count], [data-cart-count], .cart-bubble__text-count, .cart-count-bubble span, .cart-count'
      )
      .forEach(function (element) {
        element.textContent = count;

        if (element.classList.contains('hidden')) {
          element.classList.toggle('hidden', count === 0);
        }
      });

    document.querySelectorAll('.cart-bubble').forEach(function (element) {
      element.classList.toggle('visually-hidden', count === 0);
    });
  }

  function openCartDrawer() {
    var customCart = document.querySelector('[data-pristine-cart-preview]');

    if (customCart) {
      customCart.classList.add('is-open');
      customCart.setAttribute('aria-hidden', 'false');
      return;
    }

    var cartTrigger = document.querySelector(
      '[data-pristine-cart-open], [data-testid="cart-drawer-trigger"], [aria-controls="cart-drawer"], [aria-controls="CartDrawer"]'
    );

    if (cartTrigger) {
      cartTrigger.click();
      return;
    }

    var cartDrawer =
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('#cart-drawer') ||
      document.querySelector('[data-cart-drawer]');

    if (!cartDrawer) return;

    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }

    var dialog = cartDrawer.querySelector('dialog');

    if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
      dialog.showModal();
      return;
    }

    cartDrawer.classList.add('is-open', 'active', 'animate');
    cartDrawer.setAttribute('open', '');
    cartDrawer.setAttribute('aria-hidden', 'false');
  }

  async function refreshCartDrawer() {
    var root = getShopifyRoot();

    var sectionHandles = [
      'cart-drawer-section',
      'cart-drawer'
    ];

    for (var index = 0; index < sectionHandles.length; index += 1) {
      var sectionHandle = sectionHandles[index];

      try {
        var response = await fetch(
          root + '?sections=' + encodeURIComponent(sectionHandle),
          {
            method: 'GET',
            headers: {
              Accept: 'application/json'
            }
          }
        );

        if (!response.ok) continue;

        var sections = await response.json();
        var html = sections[sectionHandle];

        if (!html) continue;

        var template = document.createElement('template');
        template.innerHTML = html.trim();

        var replacement = template.content.firstElementChild;

        if (!replacement) continue;

        var existingSection =
          document.getElementById('shopify-section-' + sectionHandle) ||
          document.querySelector('[data-section-type="' + sectionHandle + '"]');

        if (existingSection) {
          existingSection.replaceWith(replacement);
          return true;
        }
      } catch (error) {
        console.warn('Cart drawer refresh skipped:', error);
      }
    }

    return false;
  }

  function setButtonState(button, state, message) {
    var label = button.querySelector('[data-pristine-quick-add-label]');

    if (state === 'loading') {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      if (label) {
        label.textContent = message || 'Adding...';
      } else {
        button.textContent = message || 'Adding...';
      }

      return;
    }

    if (state === 'success') {
      if (label) {
        label.textContent = message || 'Added';
      } else {
        button.textContent = message || 'Added';
      }

      return;
    }

    if (state === 'error') {
      if (label) {
        label.textContent = message || 'Try Again';
      } else {
        button.textContent = message || 'Try Again';
      }

      return;
    }

    button.disabled = false;
    button.removeAttribute('aria-busy');

    var originalLabel = button.getAttribute('data-original-label') || 'Quick Add';

    if (label) {
      label.textContent = originalLabel;
    } else {
      button.textContent = originalLabel;
    }
  }

  document.addEventListener(
    'click',
    async function (event) {
      var button = event.target.closest('[data-pristine-quick-add]');

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (button.disabled) return;

      var variantId = button.getAttribute('data-variant-id');
      var label = button.querySelector('[data-pristine-quick-add-label]');
      var originalLabel = label
        ? label.textContent.trim()
        : button.textContent.trim();

      button.setAttribute('data-original-label', originalLabel || 'Quick Add');

      if (!variantId) {
        console.error('Pristine Quick Add: missing data-variant-id.');
        setButtonState(button, 'error', 'Unavailable');

        window.setTimeout(function () {
          setButtonState(button, 'reset');
        }, 1400);

        return;
      }

      setButtonState(button, 'loading', 'Adding...');

      try {
        var addResponse = await fetch(getShopifyRoot() + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1
              }
            ]
          })
        });

        if (!addResponse.ok) {
          var errorData = {};

          try {
            errorData = await addResponse.json();
          } catch (error) {
            errorData = {};
          }

          throw new Error(
            errorData.description ||
            errorData.message ||
            'Unable to add this item.'
          );
        }

        setButtonState(button, 'success', 'Added');

        var cartData = await getCart();
        updateCartCount(cartData);

        await refreshCartDrawer();
        openCartDrawer();

        document.dispatchEvent(
          new CustomEvent('pristine:cart-added', {
            detail: {
              cart: cartData,
              variantId: Number(variantId)
            }
          })
        );
      } catch (error) {
        console.error('Pristine Quick Add error:', error);
        setButtonState(
          button,
          'error',
          error.message && error.message.length < 30
            ? error.message
            : 'Try Again'
        );
      } finally {
        window.setTimeout(function () {
          setButtonState(button, 'reset');
        }, 1400);
      }
    },
    true
  );
})();
/* Pristine V13 cart, product forms, drawer, recommendations, and welcome offer */
(function () {
  var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var drawer = document.querySelector('[data-pristine-drawer]');
  var body = drawer && drawer.querySelector('[data-pristine-drawer-body]');
  var footer = drawer && drawer.querySelector('[data-pristine-drawer-footer]');
  var currency = document.documentElement.lang || 'en-US';
  var lastProductId = null;

  function money(cents) {
    try {
      return new Intl.NumberFormat(currency, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function updateCounts(cart) {
    document.querySelectorAll('[data-pristine-cart-count]').forEach(function (el) { el.textContent = cart.item_count || 0; });
    var count = drawer && drawer.querySelector('[data-pristine-drawer-count]');
    if (count) count.textContent = (cart.item_count || 0) + ((cart.item_count || 0) === 1 ? ' item' : ' items');
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  async function getCart() {
    var response = await fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  }

  async function renderRecommendations(productId) {
    var section = drawer && drawer.querySelector('[data-pristine-cart-recommendations]');
    var grid = drawer && drawer.querySelector('[data-pristine-cart-rec-grid]');
    if (!section || !grid || !productId) return;
    try {
      var response = await fetch(rootUrl + 'recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=4&intent=related');
      var data = await response.json();
      var products = (data.products || []).slice(0, 4);
      if (!products.length) { section.hidden = true; return; }
      grid.innerHTML = products.map(function (p) {
        var image = p.featured_image || (p.images && p.images[0]) || '';
        var variant = p.variants && p.variants.find(function (v) { return v.available; });
        return '<article class="pristine-drawer__rec">' +
          '<a href="' + p.url + '">' + (image ? '<img src="' + image + '&width=300" alt="">' : '') + '<span>' + p.title + '</span></a>' +
          (variant ? '<button type="button" data-pristine-rec-add data-variant-id="' + variant.id + '">Add ' + money(variant.price) + '</button>' : '') +
          '</article>';
      }).join('');
      section.hidden = false;
    } catch (e) { section.hidden = true; }
  }

  async function renderCart(cart) {
    if (!drawer || !body || !footer) return;
    updateCounts(cart);
    if (!cart.items.length) {
      body.innerHTML = '<div class="pristine-drawer__empty"><h2>Your cart is empty</h2><p>Explore curated essentials for every pet.</p><a href="' + rootUrl + 'collections/all">Continue shopping</a></div>';
      footer.hidden = true;
      var recs = drawer.querySelector('[data-pristine-cart-recommendations]');
      if (recs) recs.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (item, index) {
      var image = item.image ? '<img src="' + item.image + '&width=180" alt="">' : '';
      return '<article class="pristine-drawer__item" data-line="' + (index + 1) + '">' + image +
        '<div><a class="pristine-drawer__item-title" href="' + item.url + '">' + item.product_title + '</a>' +
        (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="pristine-drawer__item-variant">' + item.variant_title + '</p>' : '') +
        '<div class="pristine-drawer__qty"><button type="button" data-cart-change="-1">−</button><span>' + item.quantity + '</span><button type="button" data-cart-change="1">+</button></div>' +
        '<button type="button" class="pristine-drawer__remove" data-cart-remove>Remove</button></div><strong>' + money(item.final_line_price) + '</strong></article>';
    }).join('');
    footer.hidden = false;
    var total = drawer.querySelector('[data-pristine-drawer-total]');
    if (total) total.textContent = money(cart.total_price);
    var points = drawer.querySelector('[data-pristine-cart-points]');
    if (points) points.textContent = Math.floor(cart.total_price / 100);
    var shippingMessage = drawer.querySelector('[data-pristine-shipping-message]');
    var shippingBar = drawer.querySelector('[data-pristine-shipping-bar]');
    var threshold = 4900;
    var remaining = Math.max(0, threshold - cart.total_price);
    if (shippingMessage) shippingMessage.textContent = remaining > 0 ? 'Add ' + money(remaining) + ' more for free standard shipping.' : 'You qualify for free standard shipping.';
    if (shippingBar) shippingBar.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
    var productId = lastProductId || (cart.items[0] && cart.items[0].product_id);
    renderRecommendations(productId);
  }

  async function refreshCart(open) {
    var cart = await getCart();
    await renderCart(cart);
    if (open) openDrawer();
    return cart;
  }

  async function addVariant(id, quantity) {
    var response = await fetch(rootUrl + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity || 1) }] })
    });
    var data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Unable to add item');
    lastProductId = data.product_id || lastProductId;
    await refreshCart(true);
  }

  document.addEventListener('click', function (event) {
    var open = event.target.closest('[data-pristine-cart-open]');
    if (open) { event.preventDefault(); refreshCart(true); return; }
    if (event.target.closest('[data-pristine-drawer-close]')) { closeDrawer(); return; }
    var viewCart = event.target.closest('[data-pristine-view-cart]');
    if (viewCart) {
      event.preventDefault();
      window.location.assign(viewCart.href || (rootUrl + 'cart'));
      return;
    }
    var checkout = event.target.closest('[data-pristine-checkout]');
    if (checkout) {
      event.preventDefault();
      window.location.assign(checkout.href || (rootUrl + 'checkout'));
      return;
    }
    var recAdd = event.target.closest('[data-pristine-rec-add]');
    if (recAdd) { recAdd.disabled = true; addVariant(recAdd.dataset.variantId, 1).catch(function () { recAdd.disabled = false; }); return; }
    var item = event.target.closest('[data-line]');
    if (!item) return;
    var line = Number(item.dataset.line);
    if (event.target.closest('[data-cart-remove]')) changeLine(line, 0);
    var change = event.target.closest('[data-cart-change]');
    if (change) {
      var current = Number(item.querySelector('.pristine-drawer__qty span').textContent || 0);
      changeLine(line, Math.max(0, current + Number(change.dataset.cartChange)));
    }
  });

  async function changeLine(line, quantity) {
    if (body) body.style.opacity = '.55';
    try {
      var response = await fetch(rootUrl + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: quantity }) });
      var cart = await response.json();
      await renderCart(cart);
    } finally { if (body) body.style.opacity = ''; }
  }

  // Keep Pristine collection-card price in sync with the selected variant.
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-pristine-card-form] select[name="id"]');
    if (!select) return;

    var form = select.closest('[data-pristine-card-form]');
    var card = form && form.closest('[data-pristine-card]');
    var price = card && card.querySelector('[data-pristine-card-price]');
    var option = select.options[select.selectedIndex];
    var button = form && form.querySelector('[data-pristine-add-button]');
    var label = form && form.querySelector('[data-pristine-add-label]');

    if (price && option && option.dataset.price) {
      price.textContent = option.dataset.price;
    }

    if (button && option) {
      var available = option.dataset.available !== 'false' && !option.disabled;
      button.disabled = !available;
      if (label) label.textContent = available ? 'Add to cart' : 'Sold out';
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-pristine-card-form], [data-product-form]');
    if (!form) return;
    event.preventDefault();
    var button = form.querySelector('[data-pristine-add-button], [data-add-button]');
    var label = form.querySelector('[data-pristine-add-label], [data-add-text]');
    var id = form.querySelector('[name="id"]');
    var qty = form.querySelector('[name="quantity"]');
    if (!id || !id.value) return;
    var old = label ? label.textContent : '';
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    if (label) label.textContent = 'Adding…';
    addVariant(id.value, qty ? qty.value : 1).then(function () {
      if (label) label.textContent = 'Added';
    }).catch(function (error) {
      if (label) label.textContent = error.message || 'Try again';
    }).finally(function () {
      setTimeout(function () { if (button) { button.disabled = false; button.removeAttribute('aria-busy'); } if (label) label.textContent = old || 'Add to cart'; }, 1300);
    });
  }, true);

  document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeDrawer(); });

  var signup = document.querySelector('[data-pristine-signup]');
  if (signup) {
    var dismissed = localStorage.getItem('pristineWelcomeDismissed');

    function closeSignup() {
      signup.hidden = true;
      signup.classList.remove('is-visible');
      signup.setAttribute('aria-hidden', 'true');
      localStorage.setItem('pristineWelcomeDismissed', '1');
      // The welcome offer must never trap the customer or leave page scrolling locked.
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }

    function openSignup() {
      signup.hidden = false;
      signup.classList.add('is-visible');
      signup.setAttribute('aria-hidden', 'false');
      // This is a dismissible offer, not a blocking modal.
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }

    signup.setAttribute('aria-hidden', 'true');
    if (!dismissed) setTimeout(openSignup, 2500);

    signup.querySelectorAll('[data-pristine-signup-close]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeSignup();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !signup.hidden) closeSignup();
    });

    var signupForm = signup.querySelector('form');
    if (signupForm) signupForm.addEventListener('submit', function () {
      localStorage.setItem('pristineWelcomeDismissed', '1');
    });
  }

  refreshCart(false).catch(function () {});
})();

/* Pristine Points deep-link support */
(function () {
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-pristine-rewards-open]');
    if (!link) return;
    event.preventDefault();
    var target = new URL(link.href, window.location.origin);
    if (window.location.pathname === target.pathname && window.location.hash === target.hash) {
      window.location.reload();
      return;
    }
    window.location.href = target.pathname + target.search + target.hash;
  });
})();
